import React from "react";
import styled from "styled-components";

import LineSeedKrRg from "../../../../atoms/text/lineSeedKr/lineSeedKrRg";

const LSRgDisplay02 = (props) => {
  return <LSRgDisplay02Wrapper {...props} />;
};

export default LSRgDisplay02;

const LSRgDisplay02Wrapper = styled(LineSeedKrRg)`
  font-size: 24px;
  font-weight: 400;
  line-height: 33.6px;
  letter-spacing: -0.6px;

  color: #222222;
`;
